module.exports = __webpack_public_path__ + "img/double-bed.6d75f475.svg";